const SMALL_WORDS = new Set(['de', 'do', 'da', 'dos', 'das', 'e', 'ou', 'a', 'o', 'as', 'os', 'em', 'no', 'na', 'nos', 'nas', 'por', 'para', 'com', 'sem', 'ao', 'aos', 'à', 'às']);
const ACRONYMS = new Set(['lgpd', 'oab', 'cpf', 'cnpj', 'stj', 'stf', 'odr']);

export function normalizeQuickNavLabel(raw) {
    const s = String(raw || '').trim();
    if (!s) return '';

    const hasLower = /[a-zà-ÿ]/.test(s);
    const hasUpper = /[A-ZÀ-Ÿ]/.test(s);
    const shouldTitleCase = hasUpper && !hasLower;
    if (!shouldTitleCase) return s;

    return s
        .toLowerCase()
        .split(/\s+/g)
        .map((word, idx) => {
            const clean = word.replace(/[^a-zà-ÿ0-9]+/gi, '');
            if (clean && ACRONYMS.has(clean.toLowerCase())) return word.toUpperCase();
            if (idx !== 0 && SMALL_WORDS.has(clean)) return word;
            return word.charAt(0).toUpperCase() + word.slice(1);
        })
        .join(' ');
}

export function resolveQuickNavBadge(block) {
    const tags = Array.isArray(block?.tags) ? block.tags.filter(Boolean) : [];
    const badge = tags[0] || block?.scope || block?.context || 'Cláusula';
    const normalized = String(badge || 'Cláusula').trim();
    if (!normalized) return '';
    if (normalized.toUpperCase() === 'UNIVERSAL') return '';
    return normalized.toUpperCase();
}

export function resolveQuickNavIcon(block, cleanedTitle = '') {
    const id = String(block?.id || '').toUpperCase();
    const rawTitle = String(block?.title || '');
    const upper = String(cleanedTitle || rawTitle || '').toUpperCase();

    const matches = (...needles) => needles.some((needle) => upper.includes(needle));

    if (matches('PARTES', 'QUALIF', 'OUTORG', 'REPRESENTANTE')) return 'fas fa-users';
    if (matches('OBJETO')) return 'fas fa-briefcase';
    if (matches('LGPD', 'PROTEÇÃO DE DADOS', 'PROTECAO DE DADOS', 'DADOS', 'PRIVAC')) return 'fas fa-shield-alt';
    if (matches('CONSENTIMENTO')) return 'fas fa-file-signature';
    if (matches('BOA-FÉ', 'BOA FE', 'VERACIDADE', 'LEALDADE', 'COOPERAÇÃO', 'COOPERACAO')) return 'fas fa-handshake';
    if (matches('OBRIGA', 'RESPONSABILIDADE')) return 'fas fa-handshake';
    if (matches('COMUNICA', 'ATENDIMENTO')) return 'fas fa-envelope-open-text';
    if (matches('DOCUMENT', 'GUARDA')) return 'fas fa-folder-open';
    if (matches('GERAIS PARA O FORO', 'FORO', 'ESPECIAIS', 'PODERES')) return 'fas fa-gavel';
    if (matches('SETORIAIS', 'SETORIAL', 'CÍVEL', 'CIVEL', 'PENAL')) return 'fas fa-balance-scale';
    if (matches('FINANCEIR', 'HONOR', 'PAGAMENTO', 'ALVARÁ', 'ALVARA', 'PLD')) return 'fas fa-landmark';
    if (matches('REEMBOLSO', 'DESPES')) return 'fas fa-receipt';
    if (matches('DIGITAIS', 'DIGITAL', 'NUVEM', 'IA', 'TECNO', 'WHATSAPP', 'ELETRÔN')) return 'fas fa-laptop';
    if (matches('INVESTIGA', 'COMPLIANCE')) return 'fas fa-search';
    if (matches('ARBITRAGEM', 'ODR', 'MULTI-PORTAS', 'MULTIPORTAS')) return 'fas fa-balance-scale';
    if (matches('SUBSTABELE')) return 'fas fa-share-alt';
    if (matches('ASSINAT', 'ASSINATURA')) return 'fas fa-file-signature';
    if (matches('VALIDADE', 'EFICÁCIA', 'EFICACIA')) return 'fas fa-file-signature';
    if (matches('FORÇA MAIOR', 'FORCA MAIOR', 'CASO FORTUITO')) return 'fas fa-cloud-bolt';
    if (matches('RESCIS', 'RESILI')) return 'fas fa-unlink';
    if (matches('DISPOSIÇÕES FINAIS', 'DISPOSICOES FINAIS')) return 'fas fa-book';
    if (id === '__DAS_PARTES') return 'fas fa-users';

    return 'fas fa-book';
}

export function buildQuickNavMeta(block, cleanTitle) {
    const rawTitle = String(block?.title || '');
    const cleaned = typeof cleanTitle === 'function' ? cleanTitle(rawTitle, block) : rawTitle;
    const label = normalizeQuickNavLabel(cleaned || 'Seção');

    return {
        label,
        icon: resolveQuickNavIcon(block, cleaned),
        badge: resolveQuickNavBadge(block),
    };
}
